import React from 'react';

import DefaultControllerConst from '../../../util/DefaultControllerConst';

class FieldListHeader extends React.Component {
  
  render() {
    const isGlobal = this.props.context === DefaultControllerConst.Global;
    return (
      <thead>
        <tr>
          <th>No</th>
          <th>Field Label</th>
          <th>Field Details</th>
          <th>Action</th>
        </tr>
      </thead>
    );
  }
}
export default FieldListHeader;